import {
  BlockNoteSchema,
  createStyleSpec,
  defaultBlockSpecs,
  defaultStyleSpecs,
} from "@blocknote/core";

const {
  video: _video,
  audio: _audio,
  file: _file,
  ...allowedBlockSpecs
} = defaultBlockSpecs;

export const COMMENT_THREAD_STYLE = "commentThread";

const commentThreadStyle = createStyleSpec(
  { type: COMMENT_THREAD_STYLE, propSchema: "string" },
  {
    render: (threadId) => {
      const span = document.createElement("span");
      span.className = "bn-thread-mark bn-comment-anchor";
      if (threadId) {
        span.dataset.bnThreadId = threadId;
      }
      return { dom: span, contentDOM: span };
    },
    parse: (element) => {
      if (element.getAttribute("data-style-type") === COMMENT_THREAD_STYLE) {
        return undefined;
      }
      if (
        element.classList?.contains("bn-comment-anchor") ||
        element.classList?.contains("bn-thread-mark")
      ) {
        return (
          element.getAttribute("data-value") ||
          element.getAttribute("data-bn-thread-id") ||
          undefined
        );
      }
      return undefined;
    },
  }
);

export const editorSchema = BlockNoteSchema.create({
  blockSpecs: allowedBlockSpecs,
  styleSpecs: {
    ...defaultStyleSpecs,
    [COMMENT_THREAD_STYLE]: commentThreadStyle,
  },
});
